import {Button, Grid, TextField, Select, MenuItem, FormControl, InputLabel, Stack, FormHelperText} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import SelectIngredienteAtivoMultiple from "../../../../../../../components/SelectsSimpleApiQuery/SelectIngredienteAtivo/Multiple";

export default function DadosCadastrais() {
    const { control, getValues, setValue, handleSubmit } = useFormContext();
    const [filters, setFilters] = useState<any | null>(null);
    const ingredientes = getValues("step01.ingredientes");
    const handleNext = getValues("funcoesAux.onNext");

    const handleNextStep = () => {
        if (!ingredientes) {
            enqueueSnackbar("Por favor, selecione pelo menos um ingrediente ativo.", {
                variant: "warning",
            });
            return;
        }
        handleNext();
    };

    const handleFilterChange = (filter: keyof typeof filters, value: any) => {
        setFilters((prev: any) => ({ ...prev, [filter]: value }));
    };

    return (
        <Grid container spacing={2}>
            <Grid size={{xs: 12, md: 6}}>
                <Controller
                    name="step01.marca_comercial"
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: { invalid, error } }) => (
                        <TextField
                            {...field}
                            label="Marca Comercial"
                            fullWidth
                            required
                            error={invalid}
                            helperText={error?.message}
                        />
                    )}
                />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Controller
                    name="step01.titular_registro"
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: { invalid, error } }) => (
                        <TextField
                            {...field}
                            label="Titular do Registro"
                            fullWidth
                            required
                            error={invalid}
                            helperText={error?.message}
                        />
                    )}
                />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Controller
                    name="step01.ingredientes"
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: {invalid, error} }) => (
                        <SelectIngredienteAtivoMultiple
                            {...field}
                            required
                            error={invalid}
                            unique_select={true}
                            value={field.value || null}
                            onChange={(ingredientes) => {
                                if (Array.isArray(ingredientes)) {
                                    const selectedValue = ingredientes.length > 0 ? ingredientes[0] : null;
                                    handleFilterChange("ingredientes", selectedValue);
                                    field.onChange(selectedValue); // Update form state
                                } else {
                                    handleFilterChange("ingredientes", ingredientes);
                                    field.onChange(ingredientes); // Update form state
                                }
                            }}
                        />
                    )}
                />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Controller
                    name="step01.classe"
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: { invalid, error } }) => (
                        <TextField
                            {...field}
                            label="Classe"
                            fullWidth
                            required
                            error={invalid}
                            helperText={error?.message}
                        />
                    )}
                />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Controller
                    name="step01.modo_acao"
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: { invalid, error } }) => (
                        <TextField
                            {...field}
                            label="Modo de Ação"
                            fullWidth
                            required
                            error={invalid}
                            helperText={error?.message}
                        />
                    )}
                />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Controller
                    name="step01.classe_toxicologica"
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: { invalid, error } }) => (
                        <TextField
                            {...field}
                            label="Classe Toxicológica"
                            fullWidth
                            required
                            error={invalid}
                            helperText={error?.message}
                        />
                    )}
                />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Controller
                    name="step01.classe_ambiental"
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: { invalid, error } }) => (
                        <TextField
                            {...field}
                            label="Classificação Ambiental"
                            fullWidth
                            required
                            error={invalid}
                            helperText={error?.message}
                        />
                    )}
                />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
                <Controller
                    name="step01.organico"
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: { invalid, error } }) => (
                        <FormControl fullWidth required error={invalid} >
                            <InputLabel id="organico-label">Orgânico</InputLabel>
                            <Select
                                {...field}
                                label="Orgânico"
                                labelId="organico-label"
                                value={field.value || ""}
                                onChange={(e) => field.onChange(e.target.value)}
                            >
                                <MenuItem value="SIM">SIM</MenuItem>
                                <MenuItem value="NAO">NAO</MenuItem>
                                <MenuItem value="OUTROS">OUTROS</MenuItem>
                            </Select>
                            {error && <FormHelperText>{error.message}</FormHelperText>}
                        </FormControl>
                    )}
                />
            </Grid>
            <Grid size={{xs: 12, md: 12}}>
                <Controller
                    name="step01.empresa_pais_tipo"
                    control={control}
                    rules={{ required: "Campo obrigatório" }}
                    render={({ field, fieldState: { invalid, error } }) => (
                        <TextField
                            {...field}
                            label="Empresa/País/Tipo"
                            fullWidth
                            required
                            error={invalid}
                            helperText={error?.message}
                        />
                    )}
                />
            </Grid>
            <Stack direction="row" justifyContent="flex-start" mt={2}>
                <Button variant="contained" onClick={handleSubmit(handleNextStep)}>
                    Avançar
                </Button>
            </Stack>
        </Grid>
    );
}